// Autogenerated file
export const tripSheetRouteOperationTypesEnum = {
    Loading: "Loading",
    Unloading: "Unloading",
    Intermediate: "Intermediate",
    Recoupling: "Recoupling",
    Control: "Control",
    Other: "Other",
};
export const tripSheetRouteOperationTypes = [
    { label: "Погрузка", value: "Loading" },
    { label: "Выгрузка", value: "Unloading" },
    { label: "Промежуточная точка", value: "Intermediate" },
    { label: "Перецепка", value: "Recoupling" },
    { label: "Контроль", value: "Control" },
    { label: "Иное", value: "Other" },
];
